export const styles = (theme) => ({
  headerContainer: {
    backgroundColor: "#f7f5f5",
    padding: 16,
    minHeight: 131,
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  headerTitle: {
    fontSize: 12,
    fontWeight: 600,
  },
  hTStyle1: {
    fontSize: 16,
    fontWeight: 600,
    color: "#D93B44",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    display: "inline-block",
    width: "100%",
  },
  headerText: {
    fontSize: 12,
    fontWeight: 400,
  },
  drawer: {
    width: 220,
    flexShrink: 0,
    backgroundColor: "#F3F3F3"
  },
  drawerPaper: {
    width: 220,
    borderRight:0,
    backgroundColor: "#F3F3F3"
  },
  menuItem: {
    color: "#404040",
    fontFamily: "Source Sans Pro,sans-serif",
    fontSize: "13px",
    background: "none",
    lineHeight: 1.25,
    padding: "16px 24px",
    textDecoration: "none",
    wordBreak: "break-word",
    wordWrap: "break-word",
    fontWeight: 300,
  },
  menuItemActive: {
    background: "#ebecec",
    fontWeight: 700,
    boxShadow: "inset 4px 0 #e30613",
  },
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
});
